module.exports = __webpack_public_path__ + "img/丽江市妇幼保健院.9c1c8526.png";